import styled from 'styled-components';

import { Hyperlink as HyperlinkComponent } from '@xingternal/hyperlink';
import { ListItem as ListComponent } from '@xingternal/list';
import { spaceXXS, xdlColorText } from '@xingternal/tokens';

export const ListItem = styled(ListComponent)`
  padding: 0;
  margin-bottom: ${spaceXXS};
  line-height: 21px;
`;

export const Hyperlink = styled(HyperlinkComponent)`
  &,
  &:visited {
    color: ${xdlColorText};
  }
`;
